import { Component, OnInit, Input, ElementRef, AfterViewInit, ViewEncapsulation, HostListener, OnChanges, SimpleChanges, AfterContentInit, AfterViewChecked } from '@angular/core';
import * as d3 from 'd3';

@Component({
  selector: 'line-chart',
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LineChartComponent implements OnInit, OnChanges, AfterViewChecked {

  constructor(private el: ElementRef) { }

  // NR: no longer used
  // @Input()
  // timeSeries: TimeSeriesValue<number>[] = [ ];

   timeSeries: TimeSeriesValue<number>[] = [ ];

    ngOnInit() {

    this.timeSeries = [
      new TimeSeriesValue(new Date(2018, 11, 1), 3000),
      new TimeSeriesValue(new Date(2019, 0, 1),  4000),
      new TimeSeriesValue(new Date(2019, 1, 1),  5000),
      new TimeSeriesValue(new Date(2019, 2, 1),  5000),
      new TimeSeriesValue(new Date(2019, 3, 1),  4000),
      new TimeSeriesValue(new Date(2019, 4, 1),  5000),
      new TimeSeriesValue(new Date(2019, 5, 1),  6000),
      new TimeSeriesValue(new Date(2019, 6, 1),  7000),
      new TimeSeriesValue(new Date(2019, 7, 1),  6000),
      new TimeSeriesValue(new Date(2019, 8, 1),  7000),
      new TimeSeriesValue(new Date(2019, 9, 1),  8000),
      new TimeSeriesValue(new Date(2019, 10, 1), 7000),
      new TimeSeriesValue(new Date(2019, 11, 1), 6000),
      new TimeSeriesValue(new Date(2020, 0, 1),  5000)
    ];
  }

  ngAfterViewChecked() {
    // NOTE: I am not sure if this is the best life cycle event to use
     // this.paint(this.timeSeries);    //NR - no graphs at the moment
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    // TODO: debounce this
    this.paint(this.timeSeries);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.timeSeries.currentValue) {
      this.paint(this.timeSeries);
    }
  }

  paint(data: TimeSeriesValue<number>[]) {
    const container = d3.select(this.el.nativeElement);
    container.select('svg').remove();
    const svg       = container.append('svg');
    const margin    = { top: 20, right: 0, bottom: 50, left: 0 };

    if (!svg.attr('width')) {
      svg.attr('width', this.el.nativeElement.clientWidth);
    }

    if (!svg.attr('height')) {
      svg.attr('height', this.el.nativeElement.clientHeight);
    }

    const width  = +svg.attr('width')  - margin.left - margin.right;
    const height = +svg.attr('height') - margin.top - margin.bottom;

    if (!width || !height) {
      return;
    }

    const axesG = svg.append('g')
                     .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
    // Scales
    const x = d3.scaleTime()
                .domain([d3.min(data, (datume) => datume.date),
                         d3.max(data, (datume) => datume.date)])
                .range([0, width]);
    const y = d3.scaleLinear()
                .domain([0, d3.max(data, (datume) => datume.value)])
                .range([height, 0]);
    // Axes
    const xAxisCall = d3.axisBottom(x)
                        .tickFormat(d3.timeFormat('%b'))
                        .tickPadding(10)
                        .tickSize(0);
    const xAxis     = axesG.append('g')
                           .attr('class', 'x-axis')
                           .attr('transform', 'translate(' + 0 + ',' + height + ')');

    // Update our axes
    xAxis.call(xAxisCall)
         .select('.domain')
         .attr('class', 'domain x-axis-line')
         .attr('stroke', '#EF7E68')
         .attr('stroke-width', '65px');

    const line = d3.line<TimeSeriesValue<number>>()
                   .x( d => x(d.date))
                   .y( d => y(d.value));


   // Update the fill area under the graph
    const fillG = svg.append('g')
                     .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

    const fillData = data.concat([]);
    fillData.unshift(new TimeSeriesValue(d3.min(data, (datume) => datume.date), 0));
    fillData.push   (new TimeSeriesValue(d3.max(data, (datume) => datume.date), 0));
    fillG.append('path')
         .datum(fillData)
         .attr('fill', '#FCD2B9')
         .attr('d', line);

    // Update our lines/paths/circles
    const dataG = svg.append('g')
                 .attr('z-index', 1)
                 .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

    dataG.append('path')
         .datum(data)
         .attr('fill',         'none')
         .attr('stroke',       '#EF7E68')
         .attr('stroke-width', '1px')
         .attr('d',            line);

    // Update our circles
    const circles = dataG.selectAll('circle')
                         .data(data);
    circles.exit().remove();
    circles
      .attr('cx', (d) => x(d.date))
      .attr('cy', (d) => y(d.value));
    circles.enter()
           .append('circle')
           .attr('cx', (d) => x(d.date))
           .attr('cy', (d) => y(d.value))
           .attr('r', 5)
           .attr('fill', '#EF7E68');


    // Add a legend
    const legend = svg.selectAll('.legend')
      .data(y.domain())
      .enter()
      .append('g')
      .attr('class', 'legend')
      .attr('transform', (d, i) => {
        return 'translate(' + 30 + ',' + 40 + ')';
      });

    legend.append('circle')
          .attr('r', 5)
          .style('fill', '#EF7E68')
          .style('stroke', '#EF7E68');

    legend.append('text')
          .attr('x', 15)
          .attr('y', 5)
          .style('fill', 'grey')
          .text((d) => 'ACTIVITY');
  }

}

export class TimeSeriesValue<T> {
  constructor(public date: Date, public value: T) {}
}
